import Backbone from 'backbone';
import budgetSplitTmpl from './budget-split.pug';
import budgetNotEditableTmpl from './budget-not-editable.pug';

export class BudgetSplitView extends Backbone.View {
  initialize(options) {
    this.i18n = options.i18n;
    this.item = options.item;
  }

  get events() {
    return {
      'click .closeimage': 'onClose',
    };
  }

  onClose() {
    this.remove();
  }

  render() {
    this.$el.html(budgetSplitTmpl({
      i18n: this.i18n,
      item: this.item,
    }));

    return this;
  }
}

export class BudgetNotEditableView extends Backbone.View {
  initialize(options) {
    this.i18n = options.i18n;
  }

  get events() {
    return {
      'click .closeimage': 'onClose',
    };
  }

  onClose() {
    this.remove();
  }

  render() {
    this.$el.html(budgetNotEditableTmpl({ i18n: this.i18n }));

    return this;
  }
}
